// extracted by mini-css-extract-plugin
module.exports = {"close":"Banner_close__tJH_2"};